import script from "./PdKeyValue.vue?vue&type=script&setup=true&lang=js"
export * from "./PdKeyValue.vue?vue&type=script&setup=true&lang=js"

import "./PdKeyValue.vue?vue&type=style&index=0&id=737b15cc&scoped=true&lang=css"
import "./PdKeyValue.vue?vue&type=style&index=1&id=737b15cc&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737b15cc"]])

export default __exports__